export const REPORT_DATA_KEYS = [
  'periodFrom',
  'periodTo',
  'slGroupType',
  'slGroupItem',
  'countryTaxType',
  'bookType',
  'reportingCurrency',
];

export const reportName = 'taxLifecycle';
